import CellHOC from '@platform/react/hoc/list/cell'
import LabeledHOC from '@platform/react/hoc/list/labeled'
import { ListItemCellOrganisationInfo } from 'ui/Element/List/Item/Cell/Organisation/Info'

export default CellHOC(
  LabeledHOC(
    props => props.label,
    ListItemCellOrganisationInfo,
  ),
)
